import { render, staticRenderFns } from "./riderwise_productdetails.vue?vue&type=template&id=5a36ec9a"
import script from "./riderwise_productdetails.vue?vue&type=script&lang=js"
export * from "./riderwise_productdetails.vue?vue&type=script&lang=js"
import style0 from "./riderwise_productdetails.vue?vue&type=style&index=0&id=5a36ec9a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports